import React, { useEffect, useState } from 'react';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import PeopleIcon from '@material-ui/icons/People';
import {
    Checkbox, Grid, Typography, FormControl, MenuItem,
    ListItemIcon, ListItemText, Box, IconButton, Select,
    FormHelperText, RadioGroup, Radio, FormControlLabel, Snackbar, TextField
} from '@material-ui/core';
import {
    behavioralDiseases, cardiovascularDiseases, endocrineDiseases,
    familyHeirs, gastrointestinalDiseases, generalDiseases, hematologicDiseases,
    immunologicDiseases, oncologicDiseases, neurologicDiseases,
    psychiatricDiseases, respiratoryDiseases, reproductiveDiseases
} from '../../../data/db';
import useStyles from './FamilyHistory.style';
import { AppSelect } from '../profiler/InputComponents';
import { MobileButton, MobileAlert } from '../../../components';

const FamilyHistory = props => {
    const classes = useStyles();
    const MenuProps = {
        PaperProps: {
            style: {
                width: 250
            }
        },
        getContentAnchorEl: null,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "center"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "center"
        },
        variant: "menu"
    };

    useEffect(() => {
        props.validator.purgeFields();
        setAutoUpdate(!autoUpdate);
    }, [props.fhGeneralDiseases, props.fhBehavioral, props.fhCardiovascular,
    props.fhEndocrine, props.fhGastrointestinal, props.fhHematologic,
    props.fhImmunologic, props.fhNeurologic, props.fhOncologic,
    props.fhPsychiatric, props.fhRespiratory, props.fhReproductive]);

    const [autoUpdate, setAutoUpdate] = useState(false);

    return (

        <Grid className={classes.root}>
            <Grid><PeopleIcon className={classes.textIcon} /></Grid>
            <Typography variant="h4" className={classes.title}>Family History</Typography>
            {props.error && !props.validator.allValid() &&
                <Typography color="error">
                    Please review your answers
                </Typography>
            }
            {/* {props.saveResult.message && props.saveResult.severity == 'success' &&
                <Typography color="success">
                    {props.saveResult.message}
                </Typography>
            } */}
            <Snackbar open={props.saveResult.message} autoHideDuration={6000} onClose={props.handleMessageClose}>
                <MobileAlert onClose={props.handleMessageClose} severity={props.saveResult.severity}>
                    {props.saveResult.message}
                </MobileAlert>
            </Snackbar>

            {/* General */}
            {props.fhGeneralDiseases?.map((general, i) =>
                <Box className={classes.item} key={i}>
                    <Box className={classes.itemHeader}>
                        <span>General #{i + 1}</span>
                        <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('generalAssessment', i)}>
                            <DeleteIcon />
                        </IconButton>
                    </Box>
                    <Box className={classes.itemBody}>

                        <Box className={classes.inputSection}>
                            <AppSelect
                                id={`general${i + 1}`}
                                value={general.disease}
                                label="Condition*"
                                items={[...generalDiseases]}
                                onChange={e => props.onFhDataChange('generalAssessment', i, 'disease', e.target.value)()}
                                fullWidth
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_general_disease`)}
                                helperText={props.validator.message(`#${i + 1}_general_disease`, general.disease, 'required')}
                            />
                        </Box>

                        <Box className={classes.inputSection} display={general.disease === 'None' || general.disease === '' ? 'none' : 'block'}>
                            <Typography variant="h5">Family Members
                            {
                            <span className={props.error && !props.validator.fieldValid(`#${i + 1}_general_heirs`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                            </Typography>
                            <FormControl variant="outlined" fullWidth >
                                <Select
                                    multiple
                                    value={general.heirs}
                                    onChange={e => props.onFhDataChange('generalAssessment', i, 'heirs', e.target.value)()}
                                    renderValue={(selected) => selected.join(", ")}
                                    MenuProps={MenuProps}
                                    error={props.error && !props.validator.fieldValid(`#${i + 1}_general_heirs`)}
                                >
                                    {familyHeirs.map((option) => (
                                        <MenuItem key={option} value={option}>
                                            <ListItemIcon>
                                                <Checkbox color="primary" checked={general.heirs.indexOf(option) > -1} />
                                            </ListItemIcon>
                                            <ListItemText primary={option} />
                                        </MenuItem>
                                    ))
                                    }
                                </Select>
                                <FormHelperText error>
                                    {props.validator.message(`#${i + 1}_general_heirs`, general.heirs, 'required')}
                                </FormHelperText>
                            </FormControl>
                            <FormControl className={classes.formControlSection} component="fieldset"
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_general_self`)}>
                                <Typography variant="h5">
                                    Do you have this condition?
                                    {
                                    <span className={props.error && !props.validator.fieldValid(`#${i + 1}_general_self`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                                    }
                                </Typography>
                                <RadioGroup
                                    row
                                    className={classes.radioGroupStyle}
                                    aria-label="Self"
                                    value={general.self}
                                    onChange={e => props.onFhDataChange('generalAssessment', i, 'self', e.target.value)()}
                                >
                                    {['Yes', 'No'].map((answer, i) =>
                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                    )}
                                </RadioGroup>
                                <FormHelperText>
                                    {props.validator.message(`#${i + 1}_general_self`, general.self, 'required')}
                                </FormHelperText>
                            </FormControl>
                        </Box>
                    </Box>
                </Box>
            )}
            <MobileButton
                onClick={props.onFhAdd('generalAssessment')}
                color="primary"
                label="Add General Assessment"
                endIcon={<AddIcon />}
            />

            {/* behavior */}
            {props.fhBehavioral?.map((behavioral, i) =>
                <Box container style={{ paddingTop: '10px' }} spacing={1} className={classes.item} key={i}>
                    <Box item xs={12} className={classes.itemHeader}>
                        <span>Behavioral #{i + 1}</span>
                        {
                            <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('behavioral', i)} >
                                <DeleteIcon />
                            </IconButton>
                        }
                    </Box>
                    <Box className={classes.itemBody}>
                        <Box className={classes.inputSection}>
                            <AppSelect
                                id={`behavioral${i + 1}`}
                                value={behavioral.disease}
                                label="Condition*"
                                items={[...behavioralDiseases]}
                                onChange={e => props.onFhDataChange('behavioral', i, 'disease', e.target.value)()}
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_behavioral`)}
                                helperText={props.validator.message(`#${i + 1}_behavioral`, behavioral.disease, 'required')}
                                fullWidth
                            />
                        </Box>
                        <Box className={classes.inputSection} display={behavioral.disease === 'None' || behavioral.disease === '' ? 'none' : 'block'}>
                            <Typography variant="h5">Family Members
                            {
                            <span className={props.error && !props.validator.fieldValid(`#${i + 1}_behavioral_heirs`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                            </Typography>
                            <FormControl variant="outlined" fullWidth>
                                <Select
                                    multiple value={behavioral.heirs}
                                    onChange={e => props.onFhDataChange('behavioral', i, 'heirs', e.target.value)()}
                                    renderValue={(selected) => selected.join(", ")}
                                    MenuProps={MenuProps}
                                    error={props.error && !props.validator.fieldValid(`#${i + 1}_behavioral_heirs`)}>
                                    {familyHeirs.map((option) => (
                                        <MenuItem key={option} value={option}>
                                            <ListItemIcon>
                                                <Checkbox color="primary" checked={behavioral.heirs.indexOf(option) > -1} />
                                            </ListItemIcon>
                                            <ListItemText primary={option} />
                                        </MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText error>
                                    {props.validator.message(`#${i + 1}_behavioral_heirs`, behavioral.heirs, 'required')}
                                </FormHelperText>
                            </FormControl>
                            <FormControl className={classes.formControlSection} component="fieldset"
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_behavioral_self`)}>
                                <Typography variant="h5">
                                    Do you have this condition?

                                    {
                                    <span className={props.error && !props.validator.fieldValid(`#${i + 1}_behavioral_self`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                                    }
                                </Typography>
                                <RadioGroup
                                    row
                                    aria-label="Self"
                                    className={classes.radioGroupStyle}
                                    value={behavioral.self}
                                    onChange={e => props.onFhDataChange('behavioral', i, 'self', e.target.value)()}
                                >
                                    {['Yes', 'No'].map((answer, i) =>
                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                    )}
                                </RadioGroup>
                                <FormHelperText>
                                    {props.validator.message(`#${i + 1}_behavioral_self`, behavioral.self, 'required')}
                                </FormHelperText>
                            </FormControl>
                        </Box>
                    </Box>
                </Box>
            )}
            <MobileButton
                onClick={props.onFhAdd('behavioral')}
                color="primary"
                label="Add Behavioral Assessment"
                endIcon={<AddIcon />}
            />

            {/* cardiovascular */}
            {props.fhCardiovascular?.map((cardiovascular, i) =>
                <Box container style={{ paddingTop: '10px' }} spacing={1} className={classes.item} key={i}>
                    <Box item xs={12} className={classes.itemHeader}>
                        <span>Cardiovascular #{i + 1}</span>
                        {
                            <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('cardiovascular', i)} >
                                <DeleteIcon />
                            </IconButton>
                        }
                    </Box>
                    <Box className={classes.itemBody}>
                        <Box className={classes.inputSection}>
                            <AppSelect
                                id={`cardiovascular${i + 1}`}
                                value={cardiovascular.disease}
                                label="Condition*"
                                items={[...cardiovascularDiseases]}
                                onChange={e => props.onFhDataChange('cardiovascular', i, 'disease', e.target.value)()}
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_cardiovascular`)}
                                helperText={props.validator.message(`#${i + 1}_cardiovascular`, cardiovascular.disease, 'required')}
                                fullWidth
                            />
                        </Box>
                        <Box className={classes.inputSection} display={cardiovascular.disease === 'None' || cardiovascular.disease === '' ? 'none' : 'block'}>
                            <Typography variant="h5">Family Members
                            {
                            <span className={props.error && !props.validator.fieldValid(`#${i + 1}_cardiovascular_heirs`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                            </Typography>
                            <FormControl variant="outlined" fullWidth>
                                <Select
                                    multiple value={cardiovascular.heirs}
                                    onChange={e => props.onFhDataChange('cardiovascular', i, 'heirs', e.target.value)()}
                                    renderValue={(selected) => selected.join(", ")}
                                    MenuProps={MenuProps}
                                    error={props.error && !props.validator.fieldValid(`#${i + 1}_cardiovascular_heirs`)}>
                                    {familyHeirs.map((option) => (
                                        <MenuItem key={option} value={option}>
                                            <ListItemIcon>
                                                <Checkbox color="primary" checked={cardiovascular.heirs.indexOf(option) > -1} />
                                            </ListItemIcon>
                                            <ListItemText primary={option} />
                                        </MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText error>
                                    {props.validator.message(`#${i + 1}_cardiovascular_heirs`, cardiovascular.heirs, 'required')}
                                </FormHelperText>
                            </FormControl>
                            <FormControl className={classes.formControlSection} component="fieldset"
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_cardiovascular_self`)}>
                                <Typography variant="h5">
                                    Do you have this condition?
                                    {
                                     <span className={props.error && !props.validator.fieldValid(`#${i + 1}_cardiovascular_self`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                                    }
                                </Typography>
                                <RadioGroup
                                    row
                                    className={classes.radioGroupStyle}
                                    aria-label="Self"
                                    value={cardiovascular.self}
                                    onChange={e => props.onFhDataChange('cardiovascular', i, 'self', e.target.value)()}
                                >
                                    {['Yes', 'No'].map((answer, i) =>
                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                    )}
                                </RadioGroup>
                                <FormHelperText>
                                    {props.validator.message(`#${i + 1}_cardiovascular_self`, cardiovascular.self, 'required')}
                                </FormHelperText>
                            </FormControl>
                        </Box>
                    </Box>
                </Box>
            )}
            <MobileButton
                onClick={props.onFhAdd('cardiovascular')}
                color="primary"
                label="Add Cardiovascular Assessment"
                endIcon={<AddIcon />}
            />

            {/* endocrine */}
            {props.fhEndocrine?.map((endocrine, i) =>
                <Box container style={{ paddingTop: '10px' }} spacing={1} className={classes.item} key={i}>
                    <Box item xs={12} className={classes.itemHeader}>
                        <span>Endocrine #{i + 1}</span>
                        {
                            <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('endocrine', i)} >
                                <DeleteIcon />
                            </IconButton>
                        }
                    </Box>
                    <Box className={classes.itemBody}>
                        <Box className={classes.inputSection}>
                            <AppSelect
                                id={`endocrine${i + 1}`}
                                value={endocrine.disease}
                                label="Condition*"
                                items={[...endocrineDiseases]}
                                onChange={e => props.onFhDataChange('endocrine', i, 'disease', e.target.value)()}
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_endocrine`)}
                                helperText={props.validator.message(`#${i + 1}_endocrine`, endocrine.disease, 'required')}
                                fullWidth
                            />
                        </Box>
                        <Box className={classes.inputSection} display={endocrine.disease === 'None' || endocrine.disease === '' ? 'none' : 'block'}>
                            <Typography variant="h5">Family Members
                            {
                            <span className={props.error && !props.validator.fieldValid(`#${i + 1}_endocrine_heirs`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                            </Typography>
                            <FormControl variant="outlined" fullWidth>
                                <Select
                                    multiple value={endocrine.heirs}
                                    onChange={e => props.onFhDataChange('endocrine', i, 'heirs', e.target.value)()}
                                    renderValue={(selected) => selected.join(", ")}
                                    MenuProps={MenuProps}
                                    error={props.error && !props.validator.fieldValid(`#${i + 1}_endocrine_heirs`)}>
                                    {familyHeirs.map((option) => (
                                        <MenuItem key={option} value={option}>
                                            <ListItemIcon>
                                                <Checkbox color="primary" checked={endocrine.heirs.indexOf(option) > -1} />
                                            </ListItemIcon>
                                            <ListItemText primary={option} />
                                        </MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText error>
                                    {props.validator.message(`#${i + 1}_endocrine_heirs`, endocrine.heirs, 'required')}
                                </FormHelperText>
                            </FormControl>
                            <FormControl className={classes.formControlSection} component="fieldset"
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_endocrine_self`)}>
                                <Typography variant="h5">
                                    Do you have this condition?
                                    {
                                    <span className={props.error && !props.validator.fieldValid(`#${i + 1}_endocrine_self`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                                    }
                                </Typography>
                                <RadioGroup
                                    row
                                    className={classes.radioGroupStyle}
                                    aria-label="Self"
                                    value={endocrine.self}
                                    onChange={e => props.onFhDataChange('endocrine', i, 'self', e.target.value)()}
                                >
                                    {['Yes', 'No'].map((answer, i) =>
                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                    )}
                                </RadioGroup>
                                <FormHelperText>
                                    {props.validator.message(`#${i + 1}_endocrine_self`, endocrine.self, 'required')}
                                </FormHelperText>
                            </FormControl>
                        </Box>
                    </Box>
                </Box>
            )}
            <MobileButton
                onClick={props.onFhAdd('endocrine')}
                color="primary"
                label="Add Endocrine Assessment"
                endIcon={<AddIcon />}
            />

            {/* gastrointestinal */}
            {props.fhGastrointestinal?.map((gastrointestinal, i) =>
                <Box container style={{ paddingTop: '10px' }} spacing={1} className={classes.item} key={i}>
                    <Box item xs={12} className={classes.itemHeader}>
                        <span>Gastrointestinal #{i + 1}</span>
                        {
                            <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('gastrointestinal', i)} >
                                <DeleteIcon />
                            </IconButton>
                        }
                    </Box>
                    <Box className={classes.itemBody}>
                        <Box className={classes.inputSection}>
                            <AppSelect
                                id={`gastrointestinal${i + 1}`}
                                value={gastrointestinal.disease}
                                label="Condition*"
                                items={[...gastrointestinalDiseases]}
                                onChange={e => props.onFhDataChange('gastrointestinal', i, 'disease', e.target.value)()}
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_gastrointestinal`)}
                                helperText={props.validator.message(`#${i + 1}_gastrointestinal`, gastrointestinal.disease, 'required')}
                                fullWidth
                            />
                        </Box>
                        <Box className={classes.inputSection} display={gastrointestinal.disease === 'None' || gastrointestinal.disease === '' ? 'none' : 'block'}>
                            <Typography variant="h5">Family Members
                            {
                            <span className={props.error && !props.validator.fieldValid(`#${i + 1}_gastrointestinal_heirs`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                            </Typography>
                            <FormControl variant="outlined" fullWidth>
                                <Select
                                    multiple value={gastrointestinal.heirs}
                                    onChange={e => props.onFhDataChange('gastrointestinal', i, 'heirs', e.target.value)()}
                                    renderValue={(selected) => selected.join(", ")}
                                    MenuProps={MenuProps}
                                    error={props.error && !props.validator.fieldValid(`#${i + 1}_gastrointestinal_heirs`)}>
                                    {familyHeirs.map((option) => (
                                        <MenuItem key={option} value={option}>
                                            <ListItemIcon>
                                                <Checkbox color="primary" checked={gastrointestinal.heirs.indexOf(option) > -1} />
                                            </ListItemIcon>
                                            <ListItemText primary={option} />
                                        </MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText error>
                                    {props.validator.message(`#${i + 1}_gastrointestinal_heirs`, gastrointestinal.heirs, 'required')}
                                </FormHelperText>
                            </FormControl>
                            <FormControl className={classes.formControlSection} component="fieldset"
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_gastrointestinal_self`)}>
                                <Typography variant="h5">
                                    Do you have this condition?
                            {
                            <span className={props.error && !props.validator.fieldValid(`#${i + 1}_gastrointestinal_self`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                                </Typography>
                                <RadioGroup
                                    row
                                    className={classes.radioGroupStyle}
                                    aria-label="Self"
                                    value={gastrointestinal.self}
                                    onChange={e => props.onFhDataChange('gastrointestinal', i, 'self', e.target.value)()}
                                >
                                    {['Yes', 'No'].map((answer, i) =>
                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                    )}
                                </RadioGroup>
                                <FormHelperText>
                                    {props.validator.message(`#${i + 1}_gastrointestinal_self`, gastrointestinal.self, 'required')}
                                </FormHelperText>
                            </FormControl>
                        </Box>
                    </Box>
                </Box>
            )}
            <MobileButton
                onClick={props.onFhAdd('gastrointestinal')}
                color="primary"
                label="Add Gastrointestinal Assessment"
                endIcon={<AddIcon />}
            />


            {/* hematologic */}
            {props.fhHematologic?.map((hematologic, i) =>
                <Box container style={{ paddingTop: '10px' }} spacing={1} className={classes.item} key={i}>
                    <Box item xs={12} className={classes.itemHeader}>
                        <span>Hematologic #{i + 1}</span>
                        {
                            <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('hematologic', i)} >
                                <DeleteIcon />
                            </IconButton>
                        }
                    </Box>
                    <Box className={classes.itemBody}>
                        <Box className={classes.inputSection}>
                            <AppSelect
                                id={`hematologic${i + 1}`}
                                value={hematologic.disease}
                                label="Condition*"
                                items={[...hematologicDiseases]}
                                onChange={e => props.onFhDataChange('hematologic', i, 'disease', e.target.value)()}
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_hematologic`)}
                                helperText={props.validator.message(`#${i + 1}_hematologic`, hematologic.disease, 'required')}
                                fullWidth
                            />
                        </Box>
                        <Box className={classes.inputSection} display={hematologic.disease === 'None' || hematologic.disease === '' ? 'none' : 'block'}>
                            <Typography variant="h5">Family Members
                            {
                            <span className={props.error && !props.validator.fieldValid(`#${i + 1}_hematologic_heirs`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                            </Typography>
                            <FormControl variant="outlined" fullWidth>
                                <Select
                                    multiple value={hematologic.heirs}
                                    onChange={e => props.onFhDataChange('hematologic', i, 'heirs', e.target.value)()}
                                    renderValue={(selected) => selected.join(", ")}
                                    MenuProps={MenuProps}
                                    error={props.error && !props.validator.fieldValid(`#${i + 1}_hematologic_heirs`)}>
                                    {familyHeirs.map((option) => (
                                        <MenuItem key={option} value={option}>
                                            <ListItemIcon>
                                                <Checkbox color="primary" checked={hematologic.heirs.indexOf(option) > -1} />
                                            </ListItemIcon>
                                            <ListItemText primary={option} />
                                        </MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText error>
                                    {props.validator.message(`#${i + 1}_hematologic_heirs`, hematologic.heirs, 'required')}
                                </FormHelperText>
                            </FormControl>
                            <FormControl className={classes.formControlSection} component="fieldset"
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_hematologic_self`)}>
                                <Typography variant="h5">
                                    Do you have this condition?
                            {
                            <span className={props.error && !props.validator.fieldValid(`#${i + 1}_hematologic_self`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                                </Typography>
                                <RadioGroup
                                    row
                                    className={classes.radioGroupStyle}
                                    aria-label="Self"
                                    value={hematologic.self}
                                    onChange={e => props.onFhDataChange('hematologic', i, 'self', e.target.value)()}
                                >
                                    {['Yes', 'No'].map((answer, i) =>
                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                    )}
                                </RadioGroup>
                                <FormHelperText>
                                    {props.validator.message(`#${i + 1}_hematologic_self`, hematologic.self, 'required')}
                                </FormHelperText>
                            </FormControl>
                        </Box>
                    </Box>
                </Box>
            )}
            <MobileButton
                onClick={props.onFhAdd('hematologic')}
                color="primary"
                label="Add Hematologic Assessment"
                endIcon={<AddIcon />}
            />


            {/* immunologic */}
            {props.fhImmunologic?.map((immunologic, i) =>
                <Box container style={{ paddingTop: '10px' }} spacing={1} className={classes.item} key={i}>
                    <Box item xs={12} className={classes.itemHeader}>
                        <span>Immunologic #{i + 1}</span>
                        {
                            <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('immunologic', i)} >
                                <DeleteIcon />
                            </IconButton>
                        }
                    </Box>
                    <Box className={classes.itemBody}>
                        <Box className={classes.inputSection}>
                            <AppSelect
                                id={`immunologic${i + 1}`}
                                value={immunologic.disease}
                                label="Condition*"
                                items={[...immunologicDiseases]}
                                onChange={e => props.onFhDataChange('immunologic', i, 'disease', e.target.value)()}
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_immunologic`)}
                                helperText={props.validator.message(`#${i + 1}_immunologic`, immunologic.disease, 'required')}
                                fullWidth
                            />
                        </Box>
                        <Box className={classes.inputSection} display={immunologic.disease === 'None' || immunologic.disease === '' ? 'none' : 'block'}>
                            <Typography variant="h5">Family Members
                            {
                            <span className={props.error && !props.validator.fieldValid(`#${i + 1}_immunologic_heirs`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                            </Typography>
                            <FormControl variant="outlined" fullWidth>
                                <Select
                                    multiple value={immunologic.heirs}
                                    onChange={e => props.onFhDataChange('immunologic', i, 'heirs', e.target.value)()}
                                    renderValue={(selected) => selected.join(", ")}
                                    MenuProps={MenuProps}
                                    error={props.error && !props.validator.fieldValid(`#${i + 1}_immunologic_heirs`)}>
                                    {familyHeirs.map((option) => (
                                        <MenuItem key={option} value={option}>
                                            <ListItemIcon>
                                                <Checkbox color="primary" checked={immunologic.heirs.indexOf(option) > -1} />
                                            </ListItemIcon>
                                            <ListItemText primary={option} />
                                        </MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText error>
                                    {props.validator.message(`#${i + 1}_immunologic_heirs`, immunologic.heirs, 'required')}
                                </FormHelperText>
                            </FormControl>
                            <FormControl className={classes.formControlSection} component="fieldset"
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_immunologic_self`)}>
                                <Typography variant="h5">
                                    Do you have this condition?
                            {
                            <span className={props.error && !props.validator.fieldValid(`#${i + 1}_immunologic_self`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                                </Typography>
                                <RadioGroup
                                    row
                                    className={classes.radioGroupStyle}
                                    aria-label="Self"
                                    value={immunologic.self}
                                    onChange={e => props.onFhDataChange('immunologic', i, 'self', e.target.value)()}
                                >
                                    {['Yes', 'No'].map((answer, i) =>
                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                    )}
                                </RadioGroup>
                                <FormHelperText>
                                    {props.validator.message(`#${i + 1}_immunologic_self`, immunologic.self, 'required')}
                                </FormHelperText>
                            </FormControl>
                        </Box>
                    </Box>
                </Box>
            )}
            <MobileButton
                onClick={props.onFhAdd('immunologic')}
                color="primary"
                label="Add Immunologic Assessment"
                endIcon={<AddIcon />}
            />

            {/* neurologic */}
            {props.fhNeurologic?.map((neurologic, i) =>
                <Box container style={{ paddingTop: '10px' }} spacing={1} className={classes.item} key={i}>
                    <Box item xs={12} className={classes.itemHeader}>
                        <span>Neurologic #{i + 1}</span>
                        {
                            <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('neurologic', i)} >
                                <DeleteIcon />
                            </IconButton>
                        }
                    </Box>
                    <Box className={classes.itemBody}>
                        <Box className={classes.inputSection}>
                            <AppSelect
                                id={`neurologic${i + 1}`}
                                value={neurologic.disease}
                                label="Condition*"
                                items={[...neurologicDiseases]}
                                onChange={e => props.onFhDataChange('neurologic', i, 'disease', e.target.value)()}
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_neurologic`)}
                                helperText={props.validator.message(`#${i + 1}_neurologic`, neurologic.disease, 'required')}
                                fullWidth
                            />
                        </Box>
                        <Box className={classes.inputSection} display={neurologic.disease === 'None' || neurologic.disease === '' ? 'none' : 'block'}>
                            <Typography variant="h5">Family Members
                            {
                            <span className={props.error && !props.validator.fieldValid(`#${i + 1}_neurologic_heirs`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                            </Typography>
                            <FormControl variant="outlined" fullWidth>
                                <Select
                                    multiple value={neurologic.heirs}
                                    onChange={e => props.onFhDataChange('neurologic', i, 'heirs', e.target.value)()}
                                    renderValue={(selected) => selected.join(", ")}
                                    MenuProps={MenuProps}
                                    error={props.error && !props.validator.fieldValid(`#${i + 1}_neurologic_heirs`)}>
                                    {familyHeirs.map((option) => (
                                        <MenuItem key={option} value={option}>
                                            <ListItemIcon>
                                                <Checkbox color="primary" checked={neurologic.heirs.indexOf(option) > -1} />
                                            </ListItemIcon>
                                            <ListItemText primary={option} />
                                        </MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText error>
                                    {props.validator.message(`#${i + 1}_neurologic_heirs`, neurologic.heirs, 'required')}
                                </FormHelperText>
                            </FormControl>
                            <FormControl className={classes.formControlSection} component="fieldset"
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_nerulogic_self`)}>
                                <Typography variant="h5">
                                    Do you have this condition?
                            {
                            <span className={props.error && !props.validator.fieldValid(`#${i + 1}_neurologic_self`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                                </Typography>
                                <RadioGroup
                                    row
                                    className={classes.radioGroupStyle}
                                    aria-label="Self"
                                    value={neurologic.self}
                                    onChange={e => props.onFhDataChange('neurologic', i, 'self', e.target.value)()}
                                >
                                    {['Yes', 'No'].map((answer, i) =>
                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                    )}
                                </RadioGroup>
                                <FormHelperText>
                                    {props.validator.message(`#${i + 1}_neurologic_self`, neurologic.self, 'required')}
                                </FormHelperText>
                            </FormControl>
                        </Box>
                    </Box>
                </Box>
            )}
            <MobileButton
                onClick={props.onFhAdd('neurologic')}
                color="primary"
                label="Add Neurologic Assessment"
                endIcon={<AddIcon />}
            />


            {/* oncologic */}
            {props.fhOncologic?.map((oncologic, i) =>
                <Box container style={{ paddingTop: '10px' }} spacing={1} className={classes.item} key={i}>
                    <Box item xs={12} className={classes.itemHeader}>
                        <span>Oncologic #{i + 1}</span>
                        {
                            <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('oncologic', i)} >
                                <DeleteIcon />
                            </IconButton>
                        }
                    </Box>
                    <Box className={classes.itemBody}>
                        <Box className={classes.inputSection}>
                            <AppSelect
                                id={`oncologic${i + 1}`}
                                value={oncologic.disease}
                                label="Condition*"
                                items={[...oncologicDiseases,"Other"]}
                                onChange={e => {
                                    props.onFhDataChange('oncologic', i, 'disease', e.target.value)();
                                    oncologic.othersiteofOncologic = ''
                                }}
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_oncologic`)}
                                helperText={props.validator.message(`#${i + 1}_oncologic`, oncologic.disease, 'required')}
                                fullWidth
                            />
                        </Box>

                        <Grid item xs={12} className={classes.appSelectGridItem}>
                                                <Box display={oncologic.disease === 'Other' ? 'block' : 'none'}>
                                                    <TextField
                                                        label="Describe the other site of cancer*"
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="normal"
                                                        inputProps={{ style: { maxLength: 500 } }}
                                                        value={oncologic.othersiteofOncologic}
                                                        onChange={props.onDataChange(i, 'othersiteofOncologic')}
                                                        error={props.error && !props.validator.fieldValid(`oncology_#${i + 1}_other_site_of_oncologic`)}
                                                        helperText={props.validator.message(`oncology_#${i + 1}_other_site_of_oncologic`, oncologic.othersiteofOncologic, `other_site_of_oncologic:${oncologic.disease}`)}
                                                       
                                                       
                                                    />
                                                </Box>
                                            </Grid>

                        <Box className={classes.inputSection} display={oncologic.disease === 'None' || oncologic.disease === '' ? 'none' : 'block'}>
                            <Typography variant="h5">Family Members
                            {
                            <span className={props.error && !props.validator.fieldValid(`#${i + 1}_oncologic_heirs`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                            </Typography>
                            <FormControl variant="outlined" fullWidth>
                                <Select
                                    multiple value={oncologic.heirs}
                                    onChange={e => props.onFhDataChange('oncologic', i, 'heirs', e.target.value)()}
                                    renderValue={(selected) => selected.join(", ")}
                                    MenuProps={MenuProps}
                                    error={props.error && !props.validator.fieldValid(`#${i + 1}_oncologic_heirs`)}>
                                    {familyHeirs.map((option) => (
                                        <MenuItem key={option} value={option}>
                                            <ListItemIcon>
                                                <Checkbox color="primary" checked={oncologic.heirs.indexOf(option) > -1} />
                                            </ListItemIcon>
                                            <ListItemText primary={option} />
                                        </MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText error>
                                    {props.validator.message(`#${i + 1}_oncologic_heirs`, oncologic.heirs, 'required')}
                                </FormHelperText>
                            </FormControl>
                            <FormControl className={classes.formControlSection} component="fieldset"
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_oncologic_self`)}>
                                <Typography variant="h5">
                                    Do you have this condition?
                            {
                            <span className={props.error && !props.validator.fieldValid(`#${i + 1}_oncologic_self`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                                </Typography>
                                <RadioGroup
                                    row
                                    className={classes.radioGroupStyle}
                                    aria-label="Self"
                                    value={oncologic.self}
                                    onChange={e => props.onFhDataChange('oncologic', i, 'self', e.target.value)()}
                                >
                                    {['Yes', 'No'].map((answer, i) =>
                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                    )}
                                </RadioGroup>
                                <FormHelperText>
                                    {props.validator.message(`#${i + 1}_oncologic_self`, oncologic.self, 'required')}
                                </FormHelperText>
                            </FormControl>
                        </Box>
                    </Box>
                </Box>
            )}
            <MobileButton
                onClick={props.onFhAdd('oncologic')}
                color="primary"
                label="Add Oncologic Assessment"
                endIcon={<AddIcon />}
            />

            {/* psychiatric */}
            {props.fhPsychiatric?.map((psychiatric, i) =>
                <Box container style={{ paddingTop: '10px' }} spacing={1} className={classes.item} key={i}>
                    <Box item xs={12} className={classes.itemHeader}>
                        <span>Psychiatric #{i + 1}</span>
                        {
                            <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('psychiatric', i)} >
                                <DeleteIcon />
                            </IconButton>
                        }
                    </Box>
                    <Box className={classes.itemBody}>
                        <Box className={classes.inputSection}>
                            <AppSelect
                                id={`psychiatric${i + 1}`}
                                value={psychiatric.disease}
                                label="Condition*"
                                items={[...psychiatricDiseases]}
                                onChange={e => props.onFhDataChange('psychiatric', i, 'disease', e.target.value)()}
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_psychiatric`)}
                                helperText={props.validator.message(`#${i + 1}_psychiatric`, psychiatric.disease, 'required')}
                                fullWidth
                            />
                        </Box>
                        <Box className={classes.inputSection} display={psychiatric.disease === 'None' || psychiatric.disease === '' ? 'none' : 'block'}>
                            <Typography variant="h5">Family Members
                            {
                            <span className={props.error && !props.validator.fieldValid(`#${i + 1}_psychiatric_heirs`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                            </Typography>
                            <FormControl variant="outlined" fullWidth>
                                <Select
                                    multiple value={psychiatric.heirs}
                                    onChange={e => props.onFhDataChange('psychiatric', i, 'heirs', e.target.value)()}
                                    renderValue={(selected) => selected.join(", ")}
                                    MenuProps={MenuProps}
                                    error={props.error && !props.validator.fieldValid(`#${i + 1}_psychiatric_heirs`)}>
                                    {familyHeirs.map((option) => (
                                        <MenuItem key={option} value={option}>
                                            <ListItemIcon>
                                                <Checkbox color="primary" checked={psychiatric.heirs.indexOf(option) > -1} />
                                            </ListItemIcon>
                                            <ListItemText primary={option} />
                                        </MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText error>
                                    {props.validator.message(`#${i + 1}_psychiatric_heirs`, psychiatric.heirs, 'required')}
                                </FormHelperText>
                            </FormControl>
                            <FormControl className={classes.formControlSection} component="fieldset"
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_psychiatric_self`)}>
                                <Typography variant="h5">
                                    Do you have this condition?
                            {
                            <span className={props.error && !props.validator.fieldValid(`#${i + 1}_psychiatric_self`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                                </Typography>
                                <RadioGroup
                                    row
                                    className={classes.radioGroupStyle}
                                    aria-label="Self"
                                    value={psychiatric.self}
                                    onChange={e => props.onFhDataChange('psychiatric', i, 'self', e.target.value)()}
                                >
                                    {['Yes', 'No'].map((answer, i) =>
                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                    )}
                                </RadioGroup>
                                <FormHelperText>
                                    {props.validator.message(`#${i + 1}_psychiatric_self`, psychiatric.self, 'required')}
                                </FormHelperText>
                            </FormControl>
                        </Box>
                    </Box>
                </Box>
            )}
            <MobileButton
                onClick={props.onFhAdd('psychiatric')}
                color="primary"
                label="Add Psychiatric Assessment"
                endIcon={<AddIcon />}
            />

            {/* respiratory */}
            {props.fhRespiratory?.map((respiratory, i) =>
                <Box container style={{ paddingTop: '10px' }} spacing={1} className={classes.item} key={i}>
                    <Box item xs={12} className={classes.itemHeader}>
                        <span>Respiratory #{i + 1}</span>
                        {
                            <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('respiratory', i)} >
                                <DeleteIcon />
                            </IconButton>
                        }
                    </Box>
                    <Box className={classes.itemBody}>
                        <Box className={classes.inputSection}>
                            <AppSelect
                                id={`respiratory${i + 1}`}
                                value={respiratory.disease}
                                label="Condition*"
                                items={[...respiratoryDiseases]}
                                onChange={e => props.onFhDataChange('respiratory', i, 'disease', e.target.value)()}
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_respiratory`)}
                                helperText={props.validator.message(`#${i + 1}_respiratory`, respiratory.disease, 'required')}
                                fullWidth
                            />
                        </Box>
                        <Box className={classes.inputSection} display={respiratory.disease === 'None' || respiratory.disease === '' ? 'none' : 'block'}>
                            <Typography variant="h5">Family Members
                            {
                            <span className={props.error && !props.validator.fieldValid(`#${i + 1}_respiratory_heirs`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                            </Typography>
                            <FormControl variant="outlined" fullWidth>
                                <Select
                                    multiple value={respiratory.heirs}
                                    onChange={e => props.onFhDataChange('respiratory', i, 'heirs', e.target.value)()}
                                    renderValue={(selected) => selected.join(", ")}
                                    MenuProps={MenuProps}
                                    error={props.error && !props.validator.fieldValid(`#${i + 1}_respiratory_heirs`)}>
                                    {familyHeirs.map((option) => (
                                        <MenuItem key={option} value={option}>
                                            <ListItemIcon>
                                                <Checkbox color="primary" checked={respiratory.heirs.indexOf(option) > -1} />
                                            </ListItemIcon>
                                            <ListItemText primary={option} />
                                        </MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText error>
                                    {props.validator.message(`#${i + 1}_respiratory_heirs`, respiratory.heirs, 'required')}
                                </FormHelperText>
                            </FormControl>
                            <FormControl className={classes.formControlSection} component="fieldset"
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_respiratory_self`)}>
                                <Typography variant="h5">
                                    Do you have this condition?
                            {
                            <span className={props.error && !props.validator.fieldValid(`#${i + 1}_respiratory_self`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                                </Typography>
                                <RadioGroup
                                    row
                                    className={classes.radioGroupStyle}
                                    aria-label="Self"
                                    value={respiratory.self}
                                    onChange={e => props.onFhDataChange('respiratory', i, 'self', e.target.value)()}
                                >
                                    {['Yes', 'No'].map((answer, i) =>
                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                    )}
                                </RadioGroup>
                                <FormHelperText>
                                    {props.validator.message(`#${i + 1}_respiratory_self`, respiratory.self, 'required')}
                                </FormHelperText>
                            </FormControl>
                        </Box>
                    </Box>
                </Box>
            )}
            <MobileButton
                onClick={props.onFhAdd('respiratory')}
                color="primary"
                label="Add respiratory Assessment"
                endIcon={<AddIcon />}
            />


            {/* reproductive */}
            {props.fhReproductive?.map((reproductive, i) =>
                <Box container style={{ paddingTop: '10px' }} spacing={1} className={classes.item} key={i}>
                    <Box item xs={12} className={classes.itemHeader}>
                        <span>Reproductive #{i + 1}</span>
                        {
                            <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('reproductive', i)} >
                                <DeleteIcon />
                            </IconButton>
                        }
                    </Box>
                    <Box className={classes.itemBody}>
                        <Box className={classes.inputSection}>
                            <AppSelect
                                id={`reproductive${i + 1}`}
                                value={reproductive.disease}
                                label="Condition*"
                                items={[...reproductiveDiseases]}
                                onChange={e => props.onFhDataChange('reproductive', i, 'disease', e.target.value)()}
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_reproductive`)}
                                helperText={props.validator.message(`#${i + 1}_reproductive`, reproductive.disease, 'required')}
                                fullWidth
                            />
                        </Box>
                        <Box className={classes.inputSection} display={reproductive.disease === 'None' || reproductive.disease === '' ? 'none' : 'block'}>
                            <Typography variant="h5">Family Members
                            {
                            <span className={props.error && !props.validator.fieldValid(`#${i + 1}_reproductive_heirs`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                            </Typography>
                            <FormControl variant="outlined" fullWidth>
                                <Select
                                    multiple value={reproductive.heirs}
                                    onChange={e => props.onFhDataChange('reproductive', i, 'heirs', e.target.value)()}
                                    renderValue={(selected) => selected.join(", ")}
                                    MenuProps={MenuProps}
                                    error={props.error && !props.validator.fieldValid(`#${i + 1}_reproductive_heirs`)}>
                                    {familyHeirs.map((option) => (
                                        <MenuItem key={option} value={option}>
                                            <ListItemIcon>
                                                <Checkbox color="primary" checked={reproductive.heirs.indexOf(option) > -1} />
                                            </ListItemIcon>
                                            <ListItemText primary={option} />
                                        </MenuItem>
                                    ))}
                                </Select>
                                <FormHelperText error>
                                    {props.validator.message(`#${i + 1}_reproductive_heirs`, reproductive.heirs, 'required')}
                                </FormHelperText>
                            </FormControl>
                            <FormControl className={classes.formControlSection} component="fieldset"
                                error={props.error && !props.validator.fieldValid(`#${i + 1}_reproductive_self`)}>
                                <Typography variant="h5">
                                    Do you have this condition?
                            {
                            <span className={props.error && !props.validator.fieldValid(`#${i + 1}_reproductive_self`) ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                            }
                                </Typography>
                                <RadioGroup
                                    row
                                    className={classes.radioGroupStyle}
                                    aria-label="Self"
                                    value={reproductive.self}
                                    onChange={e => props.onFhDataChange('reproductive', i, 'self', e.target.value)()}
                                >
                                    {['Yes', 'No'].map((answer, i) =>
                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                    )}
                                </RadioGroup>
                                <FormHelperText>
                                    {props.validator.message(`#${i + 1}_reproductive_self`, reproductive.self, 'required')}
                                </FormHelperText>
                            </FormControl>
                        </Box>
                    </Box>
                </Box>
            )}
            <MobileButton
                onClick={props.onFhAdd('reproductive')}
                color="primary"
                label="Add reproductive Assessment"
                endIcon={<AddIcon />}
            />

        </Grid >
    );

};

export default FamilyHistory
